import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSpinner } from "@awesome.me/kit-70c1f0055f/icons/duotone/solid";
import clsx from "clsx";
import { Button } from "@/components/ui/button/Button";
import { CC_GHOST_BTN } from "@/components/case-checking/caseCheckingChrome";

export function ReviewExportButton({
  onClick,
  disabled = false,
  loading = false,
  testId,
  scopeLabel,
}: {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  testId: string;
  /** Hover expands label to `Export ${scopeLabel}`. */
  scopeLabel?: string;
}) {
  return (
    <Button
      plain size="unstyled"
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      className={clsx(
        CC_GHOST_BTN,
        "group shrink-0 justify-center overflow-hidden whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-40",
      )}
    >
      <FontAwesomeIcon icon={loading ? faSpinner : faDownload} className={clsx("h-3.5 w-3.5 shrink-0", loading && "animate-spin")} />
      <span className="inline-flex min-w-0 items-center justify-center">
        <span>Export</span>
        {scopeLabel ? (
          <span className="ml-0 inline-block max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-[max-width,opacity,margin-left] duration-150 ease-in group-hover:ml-[0.25em] group-hover:max-w-[9rem] group-hover:opacity-100 group-hover:duration-300 group-hover:ease-out group-focus-visible:ml-[0.25em] group-focus-visible:max-w-[9rem] group-focus-visible:opacity-100 group-focus-visible:duration-300 group-focus-visible:ease-out">
            {scopeLabel}
          </span>
        ) : null}
      </span>
    </Button>
  );
}
